import React, { useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const MedienPopupSlider = ({ images, showDownloadIcon=true, popupColor="pink" }) => {
    // const slides = images?.length;
    const [current, setCurrent] = useState(1);
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,          // ✅ enables fade effect
        cssEase: "linear",
        beforeChange: (oldIndex, newIndex) => {
            setCurrent(newIndex + 1);
        }
    };
    const total = images?.length;
    const progress = (current / total) * 100;

    const handleDownload = async (url, fileName = "image") => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", fileName);

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <div className='slider_wrapper medien_slider'>
            <Slider {...settings}>
                {images?.map((item, index) => (
                    <div key={index} className='slider_slide_item position-relative'>
                        <img src={`https://backend.bgzurlinden.ch${item?.url}`} alt='#' className='w-100' />
                        {/* <a
                            href={`https://backend.bgzurlinden.ch${item?.url}`}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            className='img_download'
                        >
                            <img src="images/icon-download-pink.svg" alt="Download" />
                        </a> */}

                        {showDownloadIcon && <button
                            type="button"
                            className='img_download border-0 '
                            onClick={() =>
                                handleDownload(
                                    `https://backend.bgzurlinden.ch${item?.url}`,
                                    item?.name || "download"
                                )
                            }
                        >
                            {showDownloadIcon && <img src="images/icon-download-pink.svg" alt="Download" />}
                        </button>}
                    </div>
                ))}
            </Slider>
            {/* Top Section */}
            {images?.length > 1 && <div className="slider-count-progress">
                <div className="progress">
                    <div className="progress-bar" style={{ width: `${progress}%`, backgroundColor: `var(--${popupColor})` }}></div>
                </div>
            </div>}
        </div>
    )
}

export default MedienPopupSlider